import { render } from "./AgentsPerformance.vue?vue&type=template&id=f99d6782"
import script from "./AgentsPerformance.vue?vue&type=script&lang=js"
export * from "./AgentsPerformance.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/Videos/call-center-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__